import { PATH } from '@/constants/path';
import { SECTION_SLOGANS, SECTION_TITLES } from '@/constants/products';
import useHomePlanningsQuery from '@/hooks/RQHooks/market/planning/useHomePlanningsQuery';
import FeaturedSectionSkeleton from '../../../../components/common/FeaturedSectionSkeleton';
import SectionTitle from '../common/SectionTitle';
import FeaturedProductSection from './FeaturedProductSection';

const PlanningProductSection = () => {
  const { data, isPending } = useHomePlanningsQuery();

  return (
    <div>
      <SectionTitle
        title={SECTION_TITLES.PLANNING}
        slogan={SECTION_SLOGANS.PLANNING}
        link={PATH.CATEGORY.PLANNING}
      />
      {isPending ? <FeaturedSectionSkeleton /> : <FeaturedProductSection data={data ?? []} />}
    </div>
  );
};

export default PlanningProductSection;
